<template>
	<div>
		<section id="autodromo_welcome" class="section pb-0 section-components">
			<template v-if="!completo">
				<div class="container-fluid mb-5 text-center">
					<!-- Inputs -->
					<h1 class="mb-1" style="color: #000">
						<b>Trivia Mobil</b><sup>™</sup><b> F1</b>
					</h1>
					<h2 style="color: #000"><strong>Reto 02:</strong></h2>
					<div class="mt-4">
						<h4 style="color: #000">
							¡Tienes 1 minuto para enviar tu respuesta!
						</h4>
					</div>
					<h2 style="color: #000" class="mt-4"><strong>¿List@?</strong></h2>
					<h5 class="mt-4" style="color: #000">
						<strong>Da clic sobre el reloj para iniciar:</strong>
					</h5>
					<div class="text-center mt-4" id="countdown2">
						<h2 style="cursor: pointer" @click="_setInterval()" id="countdown2">
							Tiempo: {{ countdown }}
						</h2>
					</div>
					<template v-if="!mostrarPregunta">
						<br /><br />
						<hr style="border-top: 2px solid #f5f5f5 !important" />
						<br />
					</template>
					<h4 v-if="mostrarPregunta" class="mt-5" style="color: #000">
						Calcula, ¿Cuántos autos como el de Checo Pérez caben en la pista del
						Autódromo Hermanos Rodríguez?
					</h4>
				</div>

				<div v-if="mostrarPregunta" class="row justify-content-center">
					<div class="col-10">
						<center>
							<img
								:src="require('@/assets/img/pista.jpg')"
								class="img-fluid"
								alt="pista"
								id="checkImage3"
							/>
							<h5 class="mt-2">
								*Nota: La distancia comprende sólo el largo y ancho de la pista
								del autódromo Hermanos Rodriguez, considerando las dimensiones
								del monoplaza RB16B que utiliza Checo Pérez en la temporada
								2021.
							</h5>

							<h5 class="mt-5">Aquí tu respuesta:</h5>
							<input
								type="text"
								class="form-control"
								value=""
								:style="!isMobile ? 'width: 5%;' : ''"
								v-model="totalAuto"
							/>
							<small class="help-block" v-if="errorAuto"
								>Ingrese una respuesta</small
							>
							<div class="text-center">
								<button
									style="background: #007bff"
									type="button"
									class="btn btn-primary p-1 mt-4 mb-4 pl-5 pr-5"
									id="enviar"
									@click="guardarPregunta2()"
								>
									Enviar
									<b-spinner small v-if="loader"></b-spinner>
								</button>
							</div>
							<br /><br />
							<hr style="border-top: 2px solid #f5f5f5 !important" />
							<br />
						</center>
					</div>
				</div>
			</template>
			<template v-else>
				<div class="row justify-content-center container-fluid">
					<div class="col-md-6">
						<center>
							<div class="shadow-lg p-3 mt-5 bg-white text-center">
								<img
									:src="require('@/assets/img/bandera.png')"
									alt=""
									id="checkImage"
								/>
								<h2 style="color: #000">
									<b
										>Tu respuesta ha sido enviada <br />
										exitosamente</b
									>
								</h2>
								<h3 class="mt-4" style="color: #007bff">
									<b>¡Gracias por participar!</b>
								</h3>
								<h5 class="mt-4" style="color: #000">
									Recuerda:
									<b
										>27 de octubre del 2021 <br />
										publicaremos a los 10 ganadores. <br />
										<br />
										¡Descúbrelos! <br />
										en <br />
										<a
											href="https://www.facebook.com/MobilMexico"
											target="_target"
										>
											<img
												:src="require('@/assets/img/icono facebook.png')"
												alt=""
												id="checkImage2"
											/>
										</a>
										<br /><br />
										Tú puedes ser uno de ellos. <br />
										¡Mucha suerte!
									</b>
								</h5>
								<br />
								<button
									style="background: #007bff"
									class="btn btn-primary mt-4"
									@click="regresaTodo()"
								>
									Inicio
								</button>
							</div>
							<br /><br />
							<hr style="border-top: 2px solid #f5f5f5 !important" />
							<br />
						</center>
					</div>
				</div>
			</template>
		</section>
	</div>
</template>
<script>
import axios from "axios";
import CountDown from "./CountDown";
import * as moment from "moment";
export default {
	components: {
		CountDown,
	},
	props: ["customer"],
	data() {
		return {
			loader: false,
			autodromo: 0,
			isMobile: this.$mobile(),
			// contador
			countdown: moment.utc(61).format("HH:mm:ss"),
			expires_in: 61,
			interval: null,
			Clickinterval: false,
			totalAuto: "",
			completo: 0,
			errorAuto: 0,
			mostrarPregunta: 0,
			tiempo: 0,
		};
	},
	mounted() {
		setTimeout(() => {
			this.$scrollTo('#autodromo_welcome', 800, {
				offset: -100,
			});
		}, 500);
	},
	methods: {
		_setInterval: function () {
			this.mostrarPregunta = 1;
			this.tiempo = 0;
			if (this.Clickinterval == false) {
				this.interval = setInterval(() => {
					this.tiempo++;
					if (this.expires_in === 0) {
						clearInterval(this.interval);
					} else {
						this.expires_in -= 1;
						if (this.expires_in > 0) {
							this.countdown = moment
								.utc(this.expires_in * 1000)
								.subtract(1, "seconds")
								.format("HH:mm:ss");
						} else {
							this.completo = 1;
							this.mostrarPregunta = 0;
						}
					}
				}, 1000);
				this.Clickinterval = true;
			}
		},
		guardarPregunta2() {
			this.loader = true;
			if (!this.totalAuto) {
				this.errorAuto = 1;
				this.loader = false;
			} else {
				axios
					.post(this.$root.$urlApi+"api_save_autodromo", {
						customer_id: this.customer,
						respuesta: this.totalAuto,
						tiempo: this.tiempo,
					})
					.then((response) => {
						console.log(response);
						this.completo = 1;
						this.loader = false;
					})
					.catch(function (error) {
						console.log(error);
					});
			}
		},
		regresaTodo() {
			location.reload();
		},
	},
};
</script>
<style>
.rounded {
	width: 50% !important;
	border-radius: 16px !important;
}
#checkImage {
	width: 60% !important;
	margin-top: -20%;
}
#checkImage2 {
	width: 19% !important;
	color: #00579e;
}
#checkImage3 {
	width: 100% !important;
}
#countdown {
	font-size: 30px;
	color: #00579e;
}
#countdown2 {
	font-size: 30px;
	color: #00579e;
}
</style>
